// extracted by mini-css-extract-plugin
export default {"time":"LocationHour_time__-jv-c","content":"LocationHour_content__VbRZ-","day":"LocationHour_day__nR6+d","hours":"LocationHour_hours__KMCWe"};